export default "__VITE_ASSET__1F3kulw3__"